import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function AuditTrail() {
  const [entries, setEntries] = useState(null);

  useEffect(() => {
    api.get("/audit").then((r) => setEntries(r.data)).catch((e) => toast.error(formatApiError(e)));
  }, []);

  const exportCsv = () => {
    if (!entries) return;
    const rows = [["Tidsstämpel", "Användare", "Modul", "Händelse", "Hash"],
      ...entries.map((e) => [e.created_at, e.user_name, e.module, e.action, e.hash])];
    const csv = rows.map((r) => r.map((c) => `"${String(c ?? "").replace(/"/g, '""')}"`).join(";")).join("\n");
    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `reko-audit-trail-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  if (!entries) return <div className="text-sm text-slate-500">Laddar...</div>;

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-testid="audit-view">
      <div className="border-b border-slate-200 pb-4 mb-6 flex justify-between items-center flex-wrap gap-3">
        <div>
          <div className="text-xs font-bold text-blue-600 uppercase tracking-wider">FAR Kvalitetskontroll Underlag</div>
          <h2 className="text-xl font-extrabold text-slate-900">Oföränderlig Kvalitetslogg (Audit Trail)</h2>
          <p className="text-sm text-slate-500 mt-1">Automatisk tidsstämpling av alla händelser, signeringar och riskbedömningar (p. 1-2). Varje post är hash-kedjad.</p>
        </div>
        <button
          data-testid="audit-export-btn" onClick={exportCsv}
          className="bg-slate-800 hover:bg-slate-700 text-white text-xs font-bold px-3 py-2 rounded shadow flex items-center"
        >
          <Download className="w-3.5 h-3.5 mr-1.5" />Exportera CSV
        </button>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-left text-xs font-mono border-collapse" data-testid="audit-table">
          <thead>
            <tr className="bg-slate-100 text-slate-600 font-bold border-b border-slate-200">
              <th className="p-3">Tidsstämpel</th>
              <th className="p-3">Användare (Vem)</th>
              <th className="p-3">Modul</th>
              <th className="p-3">Händelse / Åtgärd</th>
              <th className="p-3">Verifiering Hash</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {entries.map((e) => (
              <tr key={e.id}>
                <td className="p-3 text-slate-500">{new Date(e.created_at).toLocaleString("sv-SE")}</td>
                <td className="p-3 font-bold text-slate-800">{e.user_name}</td>
                <td className="p-3 text-blue-600">{e.module}</td>
                <td className="p-3 font-sans">{e.action}</td>
                <td className="p-3 text-slate-400 text-[10px]">{e.hash.slice(0, 12)}...</td>
              </tr>
            ))}
            {entries.length === 0 && <tr><td colSpan={5} className="p-6 text-center text-slate-400">Inga loggposter ännu</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
